// Headphone (pocket) mode helpers: beep cues, keep-screen-awake lock, and item-name parsing.
let ctx;
export function beep(up = true) {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.frequency.value = up ? 880 : 520;
    g.gain.setValueAtTime(0.0001, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.18, ctx.currentTime + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.14);
    o.connect(g).connect(ctx.destination);
    o.start();
    o.stop(ctx.currentTime + 0.15);
  } catch { /* no audio */ }
}

let lock = null;
export async function keepAwake(on) {
  try {
    if (on && !lock && navigator.wakeLock) lock = await navigator.wakeLock.request("screen");
    if (!on && lock) { await lock.release(); lock = null; }
  } catch { lock = null; }
}

// "what's a pyrex mixing bowl worth" / "what's this worth, pyrex bowl" / "research pyrex bowl" → "pyrex mixing bowl"
export function itemName(text) {
  const t = text.toLowerCase().replace(/^(hey |ok |okay )?edgar[, ]*/, "").trim();
  const m = t.match(/what(?:'s| is) (?:a |an |the |this |my )?(.+?) worth\b/) || t.match(/worth[, ]+(?:it'?s |its |a |an |the )?(.+)$/)
    || t.match(/^(?:research|price|look up|check) (?:a |an |the )?(.+)$/);
  const name = (m?.[1] || "").replace(/^(this|it|that)$/, "").trim();
  return name.length > 2 ? name : "";
}

export const POCKET_IDLE_MS = 3 * 60 * 1000;
